import React, { useState } from "react";
import images from "../../themes/appImage";
import { Link } from "react-router-dom";
import appconstants from "../../themes/appconstant";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ButtonLayout from "../../common/layoutButton";
import { signUpLoad, userLoginLoad } from "../../redux/slices/auth.slice";

const UserLogin = () => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [authType, setAuthType] = useState("login"); // login or signup

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const initialValues = {
    email: "",
    password: "",
  };

  // Validation schema changes based on authType
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address.")
      .required("Please enter an email address."),
    ...(authType === "login" && {
      password: Yup.string().required("Please enter a password."),
    }),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    try {
      const newPayload = {
        ...values,
        deviceToken: Date.now(),
        deviceType: "web",
      };
      if (authType === "login") {
        dispatch(userLoginLoad(newPayload));
      } else {
        // Call signup API here
        const newPayload = {
          ...values,
          isResend: false,
          deviceType: "web",
        };
        dispatch(signUpLoad(newPayload));
      }
      setSubmitting(false);
    } catch (err) {
      console.log(err, "err");
    }
  };

  return (
    <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between">
      <div className="min-w-[350px] max-w-[424px] m-auto flex items-center flex-col mt-5">
        <img className="mb-5" src={images.appLogo} alt="metafit-logo" />
        <div className="w-full bg-white border shadow-metafit-shadow rounded-lg p-5 md:p-2 sm:w-[100vw]">
          <div className="text-2xl font-semibold text-dark text-center my-6">
            {authType === "login"
              ? appconstants.loginWithEmail
              : "Sign up with your email"}
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form className="w-[95%] mx-auto">
                <div className="mb-5">
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-[400] text-dark"
                  >
                    {appconstants.Email}
                  </label>
                  <Field
                    type="email"
                    name="email"
                    className="border border-gray-300 text-dark text-sm rounded-lg block w-full py-[12px] px-[16px] h-[48px] focus:outline-none focus:border-gray-300"
                    placeholder="Enter your email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500 text-xs font-normal"
                  />
                </div>

                {authType === "login" && (
                  <div className="mb-5 relative">
                    <label
                      htmlFor="password"
                      className="block mb-2 text-sm font-[400] text-dark"
                    >
                      {appconstants.password}
                    </label>
                    <Field
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="border border-gray-300 text-dark text-sm rounded-lg block w-full py-[12px] px-[16px] h-[48px] pr-[35px] focus:outline-none focus:border-gray-300"
                      placeholder="Enter your password"
                    />
                    {showPassword ? (
                      <EyeOutlined
                        className="absolute right-3 top-[44px] transform -translate-y-50 cursor-pointer"
                        onClick={togglePasswordVisibility}
                        style={{ color: "#2F2F2F66" }}
                      />
                    ) : (
                      <EyeInvisibleOutlined
                        className="absolute right-3 top-[44px] transform -translate-y-50 cursor-pointer"
                        onClick={togglePasswordVisibility}
                        style={{ color: "#2F2F2F66" }}
                      />
                    )}
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-red-500 text-xs font-normal"
                    />
                  </div>
                )}

                {authType === "login" && (
                  <div className="flex mb-[40px] justify-between items-center text-sm text-[#2F2F2FCC] font-medium">
                    <Link to="/forgot-password">
                      {appconstants.forgotPassword}
                    </Link>
                    <button
                      type="button"
                      onClick={() =>
                        setAuthType(authType === "login" ? "signup" : "login")
                      }
                      className="text-blue-500"
                    >
                      {appconstants.signup}
                    </button>
                  </div>
                )}

                {authType === "signup" && (
                  <div className="flex mb-[40px] justify-end">
                    <button
                      type="button"
                      onClick={() =>
                        setAuthType(authType === "login" ? "signup" : "login")
                      }
                      className="text-blue-500 text-sm"
                    >
                      Back to Login
                    </button>
                  </div>
                )}

                <div className="mb-5">
                  <ButtonLayout
                    text={authType === "login" ? "Login" : "Sign Up"}
                    className="ml-1/4"
                    type="submit"
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className="text-sm font-normal text-light mb-3">
        {appconstants.metafitRights}
      </div>
    </div>
  );
};

export default UserLogin;
